export default __webpack_public_path__ + "static/media/astra-digital.4dccafb7.svg";